export default "__VITE_ASSET__C_7X9Br6__"